import React from 'react';
import {Link as RouterLink} from 'react-router';
import {
    Box,
    Container,
    Typography,
    Paper,
    Link,
    Divider,
} from '@mui/material';
import {School as SchoolIcon} from '@mui/icons-material';

const Impressum = () => {
    return (
        <Box sx={{position: 'relative', minHeight: '100vh', py: 8, backgroundColor: 'background.default'}}>
            <Container maxWidth="md">
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        backgroundColor: 'background.paper',
                    }}
                >
                    {/* Header */}
                    <Box sx={{display: 'flex', alignItems: 'center', mb: 3}}>
                        <SchoolIcon sx={{mr: 2, fontSize: 40, color: 'primary.main'}}/>
                        <Typography variant="h4" color="primary" fontWeight="bold">
                            Impressum
                        </Typography>
                    </Box>

                    <Divider sx={{mb: 4}}/>

                    {/* Content */}
                    <Typography variant="h6" gutterBottom fontWeight="medium">
                        Angaben gemäß § 5 TMG
                    </Typography>

                    {/* Operator Info */}
                    <Box sx={{mb: 3}}>
                        <Typography variant="body1">
                            DuoQuanto wird betrieben von der Hochschule der Medien Stuttgart, diese ist eine Körperschaft
                            des öffentlichen Rechts. Sie wird durch den Rektor Professor Dr. Alexander W. Roos
                            gesetzlich vertreten.
                        </Typography>
                    </Box>

                    {/* Address */}
                    <Box sx={{mb: 3}}>
                        <Typography variant="body1" fontWeight="medium" gutterBottom>
                            Anschrift:
                        </Typography>
                        <Typography variant="body1">
                            Hochschule der Medien Stuttgart
                        </Typography>
                        <Typography variant="body1">
                            Nobelstrasse 10
                        </Typography>
                        <Typography variant="body1">
                            70569 Stuttgart, Deutschland
                        </Typography>
                    </Box>

                    {/* Contact */}
                    <Box sx={{mb: 3}}>
                        <Typography variant="body1" fontWeight="medium" gutterBottom>
                            Kontakt:
                        </Typography>
                        <Typography variant="body1">
                            Telefon: <Link href="tel:+49711892310">+49 711 8923 10</Link>
                        </Typography>
                    </Box>

                    {/* Content Responsibility */}
                    <Box sx={{mb: 3}}>
                        <Typography variant="body1" fontWeight="medium" gutterBottom>
                            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:
                        </Typography>
                        <Typography variant="body1">
                            Projektleitung und redaktionelle Verantwortung: Prof. Dr. Hendrik Meth
                        </Typography>
                    </Box>

                    {/* Supervisory Authority */}
                    <Box sx={{mb: 3}}>
                        <Typography variant="body1" fontWeight="medium" gutterBottom>
                            Zuständige Aufsichtsbehörde:
                        </Typography>
                        <Typography variant="body1">
                            Ministerium für Wissenschaft, Forschung und Kunst Baden-Württemberg
                        </Typography>
                        <Typography variant="body1">
                            Königstraße 46
                        </Typography>
                        <Typography variant="body1">
                            70173 Stuttgart
                        </Typography>
                    </Box>

                    {/* VAT ID */}
                    <Box sx={{mb: 3}}>
                        <Typography variant="body1" fontWeight="medium" gutterBottom>
                            Umsatzsteuer-Identifikationsnummer:
                        </Typography>
                        <Typography variant="body1">
                            „nicht zutreffend“
                        </Typography>
                    </Box>


                    {/* Back to Home Link */}
                    <Box sx={{mt: 4, pt: 3, borderTop: 1, borderColor: 'divider'}}>
                        <Link
                            component={RouterLink}
                            to="/"
                            color="primary"
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                textDecoration: 'none',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            ← Zurück zur Startseite
                        </Link>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default Impressum;